import { BrowserRouter, Route, Routes } from "react-router";
import {
  DemoLoginPage,
  GameLaunchPage,
  GamesListPage,
  LoginPage,
  PickYourPlayersPage,
  PlayGamePage,
  PowerupPlayersPage,
} from "./pages";
import { ErrorScreen } from "./screens";

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route index element={<GamesListPage />} />
        </Route>
        <Route path="/games">
          <Route index element={<GamesListPage />} />
        </Route>
        <Route path="/login">
          <Route path="/login/demo" element={<DemoLoginPage />} />
          <Route path="/login/:tenant" element={<LoginPage />} />
          <Route index element={<LoginPage />} />
        </Route>
        <Route path="/games/:gameId">
          <Route index element={<GameLaunchPage />} />
          <Route path="play" element={<PlayGamePage />} />
          <Route path="pick-your-players" element={<PickYourPlayersPage />} />
          <Route path="powerup-your-players" element={<PowerupPlayersPage />} />
        </Route>
        <Route path="oops" element={<ErrorScreen />} />
      </Routes>
    </BrowserRouter>
  );
};
